import { DefaultTheme } from 'styled-components'
import { ELanguage } from 'types/enums/ELanguage'

export enum EFont {
  // REGULAR_HE = 'InterRegularHe',
  REGULAR_HE = 'FbGofanSans-Regular',
  // REGULAR_EN = 'InterRegularEng',
  REGULAR_EN = 'FbGofanSansEng-Regular',
  // BOLD_HE = 'InterBoldHe',
  BOLD_HE = 'FbGofanSans-Bold',
  // BOLD_ENG = 'InterBoldEng',
  BOLD_ENG = 'FbGofanSansEng-Bold',
  // BLACK_HE = 'InteBlackHe',
  BLACK_HE = 'FbGofanSans-Black',
  // BLACK_ENG = 'InteBlackEng',
  BLACK_ENG = 'FbGofanSansEng-Black',
}

export interface ThemeInterface extends DefaultTheme {
  language: ELanguage
  colors: {
    white: string
    black: string
    grayText: string
    bgGray: string
    grayBorder: string
    gray200: string
    gray300: string
    primaryGreen: string
    primaryBlue: string
    lightBlack: string
    hjRed: string
  }
  fonts: {
    regularHebrew: string
    regularEnglish: string
    boldHebrew: string
    boldEnglish: string
    blackHebrew: string
    blackEnglish: string
  }
  breakpoints: {
    sm: string
  }
  media: {
    xs: (styles: TemplateStringsArray) => string
    sm: (styles: TemplateStringsArray) => string
    md: (styles: TemplateStringsArray) => string
  }
}

export const getTheme = (language: ELanguage) => ({
  language,
  colors: {
    white: '#fff',
    black: '#000',
    grayText: '#757575',
    bgGray: '#F6F6F6',
    grayBorder: '#D9D9D9',
    gray200: '#8181817f',
    gray300: '#9C9C9C',
    primaryGreen: language === ELanguage.HEBREW ? '#C00000' : '#00C000', // example of dynamic theme based on language
    hjRed: 'rgb(192, 0, 0)',
    primaryBlue: 'rgba(21, 45, 255, 1)',
    lightBlack: 'rgba(0, 0, 0, 0.1)',
  },
  fonts: {
    inter: 'Inter',
    regularHebrew: `'${EFont.REGULAR_HE}', 'Inter', sans-serif`,
    regularEnglish: `'${EFont.REGULAR_EN}', 'Inter', sans-serif`,
    boldHebrew: `'${EFont.BOLD_HE}', 'Inter', sans-serif`,
    boldEnglish: `'${EFont.BOLD_ENG}', 'Inter', sans-serif`,
    blackHebrew: `'${EFont.BLACK_HE}', 'Inter', sans-serif`,
    blackEnglish: `'${EFont.BLACK_ENG}', 'Inter', sans-serif`,
  },
  fontSizes: {
    large: '24px',
    medium: '20px',
    small: '14px',
  },
  fontWeight: {
    bold: 600,
    medium: 500,
    regular: 400,
  },
  breakpoints: {
    sm: '768px',
  },
  media: {
    xs: (styles: TemplateStringsArray) =>
      `@media (min-width: 576px) { ${styles} }`,
    sm: (styles: TemplateStringsArray) =>
      `@media (min-width: 768px) { ${styles} }`,
    md: (styles: TemplateStringsArray) =>
      `@media (min-width: 992px) { ${styles} }`,
  },
})

export const getFontFamily = (theme: ThemeInterface): string => {
  switch (theme.language) {
    case ELanguage.ENGLISH:
      return `'${EFont.REGULAR_EN}', 'Inter', sans-serif`
    case ELanguage.HEBREW:
    default:
      return `'${EFont.REGULAR_HE}', 'Inter', sans-serif`
  }
}

export const getBoldFontFamily = (theme: ThemeInterface): string => {
  switch (theme.language) {
    case ELanguage.ENGLISH:
      return `'${EFont.BOLD_ENG}, 'Inter', sans-serif'`
    case ELanguage.HEBREW:
    default:
      return `'${EFont.BOLD_HE}, 'Inter', sans-serif'`
  }
}
